import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'app/modules/shared/shared.module';
import { ConfirmDialogComponent } from './confirm-dialog.component';


@NgModule({
  declarations: [ConfirmDialogComponent],
  imports: [
    SharedModule,
    MatButtonModule,
    MatDialogModule,MatDividerModule,MatIconModule
  ],
  exports: [ConfirmDialogComponent]
})
export class ConfirmDialogModule { }

